import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import './app/App.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router';

import { Provider } from 'react-redux';
import '@/i18n/i18n';
import ErrorPage from './components/Shared/ErrorPage';
import { fetchAndActivate } from 'firebase/remote-config';
import remoteConfig from './remoteConfig';
import { persistor, store } from './app/store';
import { routes } from './app/routes';
import { RouteType } from './types/types';
import { isTruthy } from './utils';
import { LicenseInfo } from '@mui/x-license-pro';
import { PersistGate } from 'redux-persist/integration/react';
import App from './app/App';

LicenseInfo.setLicenseKey(
  'f61158f636db30b2508305b3d625af9bTz0xMzExNDAsRT0xODE1Njk1OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMS0yMDI2LFE9MixBVD1zaW5nbGUsS1Y9Mg==',
);
function startApp() {
  const container = document.getElementById('root')!;
  const root = createRoot(container);

  const router = createBrowserRouter([
    ...createRoutesFromElements(
      <Route path="/" element={<App />} errorElement={<ErrorPage />}>
        {routes.map(({ path, index, element: Component }: RouteType) => (
          <Route path={path} key={path} element={<Component />} index={index} />
        ))}
      </Route>,
    ),
  ]);

  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <RouterProvider router={router} />
        </PersistGate>
      </Provider>
    </React.StrictMode>,
  );
}

if (isTruthy(import.meta.env.VITE_IS_LOCAL)) {
  startApp();
} else {
  fetchAndActivate(remoteConfig)
    .then(() => {
      return startApp();
    })
    .catch((error) => {
      console.error('Error activating remote configs', error);
      console.warn('Starting app without remote configs...');
      return startApp();
    });
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
